// Guard for the admin-consent link (ENTRAID-248 follow-up). Microsoft sends
// the Global Admin to the link's redirect_uri, and when that parameter is
// missing it falls back to a registered reply address of the shared app,
// which may belong to another stage (a TEST onboarding once returned to
// PROD). The onboarding page therefore only offers a link that returns to
// this very portal: https://<this origin>/consent-complete, exactly.

export const CONSENT_RETURN_PATH = '/consent-complete';

export function consentReturnsHere(consentUrl, origin = window.location.origin) {
  try {
    const url = new URL(consentUrl);
    if (url.protocol !== 'https:' || url.hostname !== 'login.microsoftonline.com') return false;
    const redirect = url.searchParams.get('redirect_uri');
    return redirect === `${origin}${CONSENT_RETURN_PATH}`;
  } catch {
    return false;
  }
}

export const CONSENT_LINK_MISMATCH =
  'The consent link does not return to this portal, so it was not shown. Reload the page; if this persists, contact support@ipc-global.com.';
